import { faAngleRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useMemo, useState } from "react";
import { NavLink } from "react-router-dom";

const searchData = [
  {
    id: 1,
    title: "Acasă",
    metadata: "acasă,acasa",
    href: "/",
  },
  {
    id: 2,
    title: "Despre Noi",
    metadata: "despre,noi,about",
    href: "/despre",
  },
  {
    id: 3,
    title: "Servicii",
    metadata: "servicii,services",
    href: "/servicii",
  },
  {
    id: 4,
    title: "Contact",
    metadata: "ajutor,contact,telefon,email,help,formular,adresa,adresă",
    href: "/contact",
  },
  {
    id: 5,
    title: "Calculează RCA",
    metadata: "rca,asigurare,comparator,casco,emite,asistent",
    href: "/rca",
  },
  {
    id: 6,
    title: "Asigurări",
    metadata: "rca,asigurare,casco,asigurări,asigurari,travel,polita,poliță",
    href: "/servicii/asigurari",
  },
  {
    id: 7,
    title: "Daune",
    metadata: "daune,ajutor",
    href: "/servicii/daune",
  },
  {
    id: 8,
    title: "Politica De Confidențialitate",
    metadata: "gdpr,politica,politică,confidențialitate,privacy",
    href: "/politica-de-confidentialitate",
  },
  {
    id: 9,
    title: "Termeni și Condiții",
    metadata: "termeni,condiții,condiții,terms",
    href: "/termeni-si-conditii",
  },
  {
    id: 10,
    title: "Calculează PAD",
    metadata: "pad,asigurare,comparator,casa,emite,asistent",
    href: "/pad",
  },
];

const SearchOption = ({ onClose }) => {
  const [search, setSearch] = useState("");

  const results = useMemo(() => {
    const searchedText = search.toLowerCase().trim();
    let defaultResults = [...searchData].splice(0, 3);

    if (searchedText.length < 2) {
      return defaultResults;
    }

    const searchedChars = searchedText.split(" ");

    const results = searchData.filter((item) => {
      let itemFound = false;

      searchedChars.forEach((c) => {
        if (item.metadata.includes(c)) {
          itemFound = true;
        }
      });

      return itemFound;
    });

    if (!results.length) return defaultResults;
    return results;
  }, [search]);

  return (
    <div className="bg-metal-900 fixed left-0 right-0 top-0 z-50 flex animate-bounce items-center justify-center">
      <div className="relative h-auto w-full max-w-xl p-4">
        <div className="relative rounded-medium bg-white p-2.5 shadow-box dark:bg-dark-200 ">
          <div className=" rounded border border-dashed border-gray-100 p-10 dark:border-borderColor-dark ">
            <div className="bg flex items-center justify-between border-b border-dashed border-b-borderColor pb-5 dark:border-borderColor-dark">
              <h3 className="text-paragraph dark:text-white">Caută</h3>
              <button
                onClick={onClose}
                className="text-paragraph dark:text-white"
                id="ok-btn"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  fill="currentColor"
                  viewBox="0 0 256 256"
                >
                  <rect width="256" height="256" fill="none"></rect>
                  <circle
                    cx="128"
                    cy="128"
                    r="96"
                    fill="none"
                    stroke="currentColor"
                    strokeMiterlimit="10"
                    strokeWidth="16"
                  ></circle>
                  <line
                    x1="160"
                    y1="96"
                    x2="96"
                    y2="160"
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="16"
                  ></line>
                  <line
                    x1="160"
                    y1="160"
                    x2="96"
                    y2="96"
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="16"
                  ></line>
                </svg>
              </button>
            </div>
            <form className="mt-5">
              <div>
                <div className="flex">
                  <div className="relative w-full">
                    <input
                      className="border- placeholder:text-metal-400 block w-full rounded-medium border border-borderColor bg-transparent  px-5 py-2.5 text-paragraph outline-none transition-all duration-300 placeholder:text-paragraph focus:border-primary focus:outline-none focus:ring-0 dark:text-white dark:placeholder:text-white"
                      id="#id-10"
                      placeholder="Caută informații..."
                      type="text"
                      name="search-data"
                      value={search}
                      onChange={(event) => setSearch(event.target.value)}
                    />
                  </div>
                </div>
              </div>
            </form>
            <div className="pt-5">
              <h3 className="mb-1">Rezultatele Căutării</h3>
              <ul className="[&>*:not(:last-child)]:border-b [&>*:not(:last-child)]:border-dashed  [&>*:not(:last-child)]:border-gray-100  dark:[&>*:not(:last-child)]:border-borderColor-dark">
                {results.map((r) => (
                  <li key={r.id} className="group ">
                    <NavLink
                      className="flex items-center justify-between py-5 font-medium"
                      to={r.href}
                    >
                      {r.title}
                      <FontAwesomeIcon icon={faAngleRight} />
                    </NavLink>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SearchOption;
